import colors from '@packs/assets/theme/base/colors';

const { grey } = colors;

export default () => ({
  wrapper: {
    backgroundColor: grey[100]
  },
  container: {
    maxWidth: '1162px',
    mx: 'auto',
    px: 2,
    py: {
      xs: 6,
      lg: 15
    }
  },
  title: {
    mb: { xs: 4, lg: 8 }
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: {
      xs: 'column',
      lg: 'row'
    },
    gap: {
      xs: 3,
      lg: 0
    }
  },
  leftContent: {
    pr: { xs: 0, lg: 10 },
    order: { xs: 2, lg: 1 }
  },
  rightContent: {
    width: '100%',
    maxWidth: '483px',
    order: { xs: 1, lg: 2 },
    alignSelf: { xs: 'center', lg: 'flex-start' },
    borderRadius: '20px',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }
});
